import '../scss/index.scss';

const fxp = document.querySelector('.fxp');
const forms = document.querySelectorAll('form');

forms.forEach(form => {
    form.addEventListener('submit', () => {
        fxp.classList.add('loading');
    });
});